import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { Modal } from 'components';
import { getAddressURL } from 'services/commons';
import { useStorage64 } from 'hooks/useStorageBase64';
import { useWindowSize } from 'hooks';
import getAddress, {
  postAddress,
} from 'pages/Header/Content/services/getAddress';
import { SEND_DIRECTIONS } from 'constants/storage64';
import {
  ADDRESS_STEPS,
  TITLES_BY_STEPS,
  ADDRESS_SCHEMAS,
  ADDRESS_FORMS,
} from './constants';
import { addressFormatter, postAddressFormatter } from './formatter';
import { initialValues } from './validations';
import './AddressModal.scss';

const AddressModal = ({ showModal, onHide, onSave }) => {
  const [currentStep, setCurrentStep] = useState(ADDRESS_STEPS.ONE);
  const [userAddress, setUserAddress] = useState([]);
  const [addressOptions, setAddressOptions] = useState([]);
  const [hasAddAddress, setHasAddAddress] = useState(false);
  const [directionsData, setDirectionsData] = useStorage64(SEND_DIRECTIONS, '');
  const [, { isMobile }] = useWindowSize();

  const submitStepOne = (...args) => {
    submitStepThree(...args);
  };

  const submitStepTwo = () => {
    setHasAddAddress(true);
    setCurrentStep(ADDRESS_STEPS.THREE);
  };

  const submitStepThree = (formValues, { resetForm }, newAddress = null) => {
    const findAddress = ({ id }) => id === Number(formValues.address);
    const address = addressOptions.find(findAddress);
    const addressToUse = newAddress || address;

    const withExistingAddress =
      formValues.address &&
      !formValues.city &&
      currentStep === ADDRESS_STEPS.ONE;

    const url = getAddressURL(withExistingAddress ? address : formValues);

    if (addressToUse) {
      const formattedValues = addressFormatter(formValues, addressToUse);

      onSave({
        ...formattedValues,
        url,
        valid: true,
      });
      resetForm();
      setCurrentStep(ADDRESS_STEPS.ONE);
      onHide();
    }
  };

  const ADDRESS_SUBMITS = {
    [ADDRESS_STEPS.ONE]: submitStepOne,
    [ADDRESS_STEPS.TWO]: submitStepTwo,
    [ADDRESS_STEPS.THREE]: submitStepThree,
  };

  const handleSubmit = (formValues, formHelpers) => {
    const onSubmit = ADDRESS_SUBMITS[currentStep];

    if (currentStep === ADDRESS_STEPS.THREE && hasAddAddress) {
      const formattedData = postAddressFormatter(formValues);
      let newAddressId = false;
      postAddress(formattedData)
        .then(getAddress)
        .then((data) => {
          newAddressId = data.address[data.address.length - 1].id;
          setDirectionsData(data);
        })
        .then(() => {
          onSubmit({ ...formValues, id: newAddressId }, formHelpers, {
            ...formattedData,
            id: newAddressId,
          });
        })
        .catch(console.error);
      return;
    }

    onSubmit(formValues, formHelpers);
  };

  const handleCancel = () => {
    if (currentStep === ADDRESS_STEPS.ONE) {
      onHide();
      return;
    }
    if (currentStep === ADDRESS_STEPS.TWO) {
      setCurrentStep(ADDRESS_STEPS.ONE);
    }
    if (currentStep === ADDRESS_STEPS.THREE) {
      setCurrentStep(ADDRESS_STEPS.TWO);
    }
  };

  useEffect(() => {
    if (directionsData && directionsData.address) {
      setUserAddress(directionsData.address);
    }
  }, [directionsData]);

  const AddressForm = ADDRESS_FORMS[currentStep];
  const schema = ADDRESS_SCHEMAS[currentStep];

  const helpers = {
    setCurrentStep,
    userAddress,
    setAddressOptions,
    addressOptions,
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={handleSubmit}
      validateOnChange
      validateOnBlur
    >
      {(formikProps) => (
        <Modal
          show={showModal}
          onHide={onHide}
          onClose={handleCancel}
          backdrop="static"
          keyboard={false}
          title={TITLES_BY_STEPS[currentStep]}
          subtitle="Aquí haremos llegar todos tus regalos"
          onSubmit={formikProps.handleSubmit}
          variant="completed"
          variantOnlyInMobile
          type={isMobile ? 'single' : 'action'}
          submitLabel={isMobile ? 'Siguiente' : ''}
        >
          {AddressForm && <AddressForm {...formikProps} {...helpers} />}
        </Modal>
      )}
    </Formik>
  );
};

export default AddressModal;
